import BituminousWaterproofingMembrane from '@/containers/Services/BituminousWaterproofingMembrane';
import CementitiousWaterproofingMembrane from '@/containers/Services/CementitiousWaterproofing';
import ContactUsPage from '@/containers/Contact/ContactUsPage';
import GalleryPage from '@/containers/Gallery/GalleryPage';
import Home from '@/containers/Home/Home';
import InjectionWaterproofing from '@/containers/Services/InjectionWaterproofing';
import LiquidWaterproofingMembrane from '@/containers/Services/LiquidWaterproofingMembrane';
import PolyurethaneWaterproofing from '@/containers/Services/PolyurethaneWaterproofing';
import ProductsPage from '@/containers/Products/ProductsPage';
import RoofWaterproofing from '@/containers/Services/RoofWaterproofing';
import ServicesPage from '@/containers/Services/ServicesPage';
import SheetMembranes from '@/containers/Services/SheetMembranes';
import VistaAfaSuper from '@/containers/Products/VistaAfaSuper';
import VistaCrystalPlus from '@/containers/Products/VistaCrystalPlus';
import VistaFlexSealPlus from '@/containers/Products/VistaFlexSealPlus';
import VistaIwa from '@/containers/Products/VistaIwa';
import VistaNoThree from '@/containers/Products/VistaNoThree';
import VistaNoTwo from '@/containers/Products/VistaNoTwo';
import VistaPowerSilicaFume from '@/containers/Products/VistaPowerSilicaFume';
import VistaSbrLatexPlus from '@/containers/Products/VistaSbrLatexPlus';
import VistaShotX from '@/containers/Products/VistaShotX';
import VistaSuperCrete from '@/containers/Products/VistaSuperCrete';
import VistaSuperPlastHs from '@/containers/Products/VistaSuperplast';
import VistaSuperplastHs1000 from '@/containers/Products/VistaSuperplastHs1000';
import AboutUsPage from '@/containers/About/AboutUsPage';
import ExpansionJoints from '@/containers/Services/ExpansionJoints';
import TermsOfUse from '@/components/elements/Footer/footeritems/TermsOfUse'; 
import CookiePolicy from '@/components/elements/Footer/footeritems/CookiePolicy';
import PrivacyPolicy from '@/components/elements/Footer/footeritems/PrivacyPolicy';
import VistaCrackStop from '@/containers/Products/VistaCracksTop';
import VistaSuperplast from '@/containers/Products/VistaSuperplast';
import VistaSuperplastPQC from '@/containers/Products/VistaSuperplastPQC';
import VistaSuperplastSCC from '@/containers/Products/VistaSuperPlastSCC';
import VistaSuperplastHs500 from '@/containers/Products/VIstaSuperplastHs500';
import CrystallineWaterproofing from '@/containers/Services/CrystallineWaterproofing';
import { Component } from 'lucide-react';
import VistaPumpcare from '@/containers/Products/VistaPumpcare';
import VistaMROB from '@/containers/Products/VistaMROB';

export const publicRoutes = [
  {
    path: '',
    component: <Home />,
  },
  {
    path: 'about',
    component: <AboutUsPage />,
  },
  {
    path: 'contact',
    component: <ContactUsPage />,
  },
  {
    path: 'products',
    component: <ProductsPage />,
  },
  {
    path: 'services',
    component: <ServicesPage />,
  },
  {
    path: 'gallery',
    component: <GalleryPage />,
  },

  {
    path: 'services/bituminous-waterproofing-membrane',
    component: <BituminousWaterproofingMembrane />,
  },
  {
    path: 'services/cementitious-waterproofing',
    component: <CementitiousWaterproofingMembrane />,
  },
  {
    path: 'services/injection-waterproofing',
    component: <InjectionWaterproofing />,
  },
  {
    path: 'services/liquid-waterproofing-membrane',
    component: <LiquidWaterproofingMembrane />,
  },
  {
    path: 'services/polyurethane-waterproofing',
    component: <PolyurethaneWaterproofing />,
  },
  {
    path: 'services/roof-waterproofing',
    component: <RoofWaterproofing />,
  },
  {
    path: 'services/sheet-membranes',
    component: <SheetMembranes />,
  },
  {
    path: 'services/expansion-joints',
    component: <ExpansionJoints />,
  },
  {
    path: 'services/crystalline-waterproofing',
    component: <CrystallineWaterproofing />,
  },



  {
    path: 'products/vista-afa-super',
    component: <VistaAfaSuper />,
  },
  {
    path: 'products/vista-crystal-plus',
    component: <VistaCrystalPlus />,
  },
  {
    path: 'products/vista-flex-seal-plus',
    component: <VistaFlexSealPlus />,
  },
  {
    path: 'products/vista-iwa',
    component: <VistaIwa />,
  },
  {
    path: 'products/vista-no-2',
    component: <VistaNoTwo />,
  },
  {
    path: 'products/vista-no-3',
    component: <VistaNoThree />,
  },
  {
    path: 'products/vista-power-silica-fume',
    component: <VistaPowerSilicaFume />,
  },
  {
    path: 'products/vista-sbr-latex-plus',
    component: <VistaSbrLatexPlus />,
  },
  {
    path: 'products/vista-shot-x',
    component: <VistaShotX />,
  },
  {
    path: 'products/vista-super-crete',
    component: <VistaSuperCrete />,
  },
  {
    path: 'products/vista-superplast-hs-500',
    component: <VistaSuperplastHs500 />,
  },
  {
    path: 'products/vista-superplast-hs-1000',
    component: <VistaSuperplastHs1000 />,
  },
  {
    path: 'products/vista-superplast',
    component: <VistaSuperplast />,
  },
  {
    path: 'products/vista-superplast-pqc',
    component: <VistaSuperplastPQC />,
  },
  {
    path: 'products/vista-superplast-scc',
    component: <VistaSuperplastSCC />,
  },
  {
    path: 'products/vista-crack-stop',
    component: <VistaCrackStop />,
  },
  {
    path: 'products/vista-pumpcare',
    component: <VistaPumpcare />,
  },
  {
    path: 'products/vista-mrob',
    component: <VistaMROB />,
  },
  

  {
    path: '/terms',
    component: <TermsOfUse />,
  },
  {
    path: '/cookie-policy',
    component: <CookiePolicy />,
  },
  {
    path: '/privacy-policy',
    component: <PrivacyPolicy />,
  },
  
];
